export enum DashboardTrend {
  Up = "Up",
  Down = "Down",
  Stable = "Stable",
}
